import { Link } from "react-router-dom";

import { useMe } from "@/lib/auth";

/** Perms the backend gates behind MFA (mirror of
 * `apps.accounts.permissions_registry.MFA_REQUIRED_PERMS`). Keeping
 * this list in sync is a manual step at v1 — there's no shared schema.
 * If you add a perm to the backend set, add it here too. */
const MFA_GATED_PERMS = new Set([
  "org.update",
  "org.member.invite",
  "org.member.remove",
  "role.create",
  "role.update",
  "role.delete",
  "retention.update",
  "dsr.execute",
  "billing.update",
]);

/** Phase 2G hardening — surfaces a "set up MFA" nudge when the user
 * holds an MFA-gated perm but hasn't enrolled. Without this they only
 * discover the gate by getting a 403 on a write call; the banner is a
 * proactive path to enrollment. Renders nothing when MFA is already
 * on or the user holds no gated perms. */
export function MfaRequiredBanner() {
  const me = useMe();
  if (!me.data) return null;
  if (me.data.user.mfa_enabled) return null;
  const hasGatedPerm = me.data.permissions.some((p) =>
    MFA_GATED_PERMS.has(p),
  );
  if (!hasGatedPerm) return null;

  return (
    <div
      data-testid="mfa-required-banner"
      className="border-b border-amber-500/40 bg-amber-500/10 px-6 py-2 text-sm text-amber-200"
    >
      <span className="font-semibold">MFA required:</span>{" "}
      your role can change billing, members, or run DSR — please{" "}
      <Link to="/account" className="underline hover:text-amber-100">
        enroll a TOTP device
      </Link>{" "}
      to continue using those features.
    </div>
  );
}
